import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {AiOutlineClose, AiOutlineMenu} from "react-icons/ai";

export function Navbar() {
  const [navBar, setNavBar] = useState(false);

  const handleNavBar = () => {
    setNavBar(!navBar);
  };

  const isLoggedIn = typeof window !== "undefined" && Boolean(localStorage.getItem("token"));

  const navLinks = [
    ...(isLoggedIn ? [{path: "/gerechten", label: "Gerechten"}] : []),
    {path: "/weekmenu", label: "Weekmenu"},
    {path: "/highteas", label: "High Teas"},
    {path: "/contact", label: "Contact"},
    ...(isLoggedIn ? [{
      path: "/login",
      label: <img className="navbar-icon" src={require("../Images/user.png")} alt={""}/>
    }] : [{
      path: "/winkelmandje",
      label: <img className="navbar-icon" src={require("../Images/basket.png")} alt={""}/>
    }]),
  ];

  return (
    <div className="navbar">
      <div className="navbar-logo-container">
        <Link to="/">
          <img className="navbar-logo" src={require("../Images/smaeck.jpg")} alt=""/>
        </Link>
        <h1>
          <Link className="title" to="/">
            Smaeck.
          </Link>
        </h1>
      </div>

      <ul className="navbar-links">
        {navLinks.map((link) => (
          <li key={link.path} className="navbar-link">
            <Link to={link.path}>{link.label}</Link>
          </li>
        ))}
      </ul>

      {navBar && (
        <div
          className="navbar-overlay"
          onClick={() => setNavBar(false)}
          onTouchEnd={() => setNavBar(false)}
        />
      )}

      <ul onClick={handleNavBar} className="navbar-burger-icon">
        <li>
          {navBar ? <AiOutlineClose size={25}/> : <AiOutlineMenu size={25}/>}
        </li>
      </ul>

      <div
        className={
          navBar
            ? "navbar-burger-menu"
            : "navbar-burger-menu--closed"
        }>

        <ul className="navbar-burger-links">
          {navLinks.map((link) => (
            <li key={link.path} className="burger-link">
              <Link to={link.path}>{link.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Navbar;